<template>
  <div class="dropdown-multiple-select-menu-button">
    <p v-if="title" class="dropdown-multiple-select-menu-button_title mb-8">
      {{ $t(title) }}<span v-if="required" class="red">*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      v-click-outside="$_dropdownClose"
      :rules="rules"
      class="dropdown-multiple-select-menu-button_content-wrap"
    >
      <div
        class="dropdown-multiple-select-menu-button_content"
        :class="{
          outline: outline,
          narrow: narrow,
          wide: wide,
          disabled: disabled,
          error: errors.length > 0,
        }"
      >
        <i v-if="leadingIcon" class="icon leading-icon" :class="leadingIcon" />
        <button class="input-button" @click="$_onclick()">
          <p class="select">
            {{ _computedButtonTextLabel }}
          </p>
          <p v-if="_hasValue" class="num" :class="{ 'has-cancel-icon': _isDisplayCancelIcon }">
            {{ _remainNumber }}
          </p>
          <i v-if="_isDisplayCancelIcon" class="cancel-icon icon-cancel" @click.stop="$_onCancel" />
        </button>
        <i
          v-if="outline || disabled"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{ show: dropdownMenuShow }"
        />
        <i
          v-else-if="!outline && !dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div v-if="dropdownMenuShow && !isAddActive" class="dropdown-menu">
            <perfect-scrollbar class="ps dropdown-scrollable-content">
              <WsTextChip001
                v-if="remindText"
                thin
                :textLabel="remindText"
                :color="remindTextColor"
                :leadingIcon="remindTextIcon"
              />
              <div
                v-for="(firstLayer, firstLayerKey) in menuItems"
                :key="firstLayerKey"
                class="classification-list"
              >
                <!-- First Layer -->
                <div class="classification-title">
                  <span>{{ $t(firstLayer.title) }}</span>
                </div>
                <div class="classification-subtitle">
                  <!-- Second Layer -->
                  <div
                    v-for="(secondLayer, secondLayerKey) in firstLayer.menu"
                    :key="secondLayerKey"
                  >
                    <label>
                      <input
                        type="checkbox"
                        :checked="value.includes(secondLayer.value)"
                        @change="$_onChange($event, secondLayer.value)"
                      />
                      <div class="checkbox-icon">
                        <i class="checked icon-check-box" />
                        <i class="unchecked icon-check-box-outline-blank" />
                      </div>
                      <LvText
                        h6
                        :red="secondLayer.color === 'red'"
                        :blue="secondLayer.color === 'blue'"
                        :green="secondLayer.color === 'green'"
                        :yellow="secondLayer.color === 'yellow'"
                        :lightGray="secondLayer.color === 'lightGray'"
                        class="classification-subtitle__text"
                        >{{ $t(secondLayer.text) }}</LvText
                      >
                    </label>
                  </div>
                </div>
              </div>
            </perfect-scrollbar>
            <div v-if="createBtnText || editBtnText" class="dropdown-menu_btns">
              <div v-if="createBtnText" class="dropdown-menu_btn" @click="$_addFieldOpen()">
                <i class="icon-add-circle dropdown-menu_btn-icon" />
                <p class="dropdown-menu_btn-text">
                  {{ createBtnText }}
                </p>
              </div>
              <div v-if="editBtnText" class="dropdown-menu_btn" @click="$_btnClick()">
                <i class="icon-edit dropdown-menu_btn-icon" />
                <p class="dropdown-menu_btn-text">
                  {{ editBtnText }}
                </p>
              </div>
            </div>
          </div>
        </transition>
        <transition mode="out-in">
          <ValidationObserver
            v-if="isAddActive"
            ref="createObserve"
            class="dropdown-menu"
            :class="{ show: isAddActive }"
          >
            <div class="menu-title">
              <i class="icon-arrow-left menu-title_icon" @click="$_addFieldClose()" />
              <p class="menu-title_text">
                {{ addTextLabel }}
              </p>
            </div>
            <div class="dropdown-content">
              <LlState
                v-for="(fieldItem, fieldKey) in addFieldsType"
                :key="fieldKey"
                v-model="createData[fieldKey]"
                required
                :type="fieldItem.type"
                :title="fieldItem.title"
                :placeholder="fieldItem.placeholder"
                :rules="fieldItem.rules"
                :is-required="fieldItem.required"
              />
              <div class="btns">
                <div class="btn">
                  <WsButton001 out-line narrow @click="$_addFieldClose()">
                    {{ $t('取消') }}
                  </WsButton001>
                </div>
                <div class="btn">
                  <WsButton001 @click="$_addSubmitClick()">
                    {{ $t('送出') }}
                  </WsButton001>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </transition>
      </div>
      <div v-if="!noErrorText && errors.length > 0" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
      <input type="hidden" :value="value" />
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'DropdownMultipleSelectMenuButton',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    rules: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    selectValue: {
      type: Array,
      default() {
        return [];
      },
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    addFieldsType: {
      type: Object,
      default() {
        return {};
      },
    },
    addFields: {
      type: Object,
      default() {
        return {};
      },
    },
    addTextLabel: {
      type: String,
      default: '',
    },
    addUrl: {
      type: String,
      default: '',
    },
    editBtnText: {
      type: String,
      default: '',
    },
    createBtnText: {
      type: String,
      default: '',
    },
    addLicenseTemplatePopUp: {
      type: Boolean,
      default: false,
    },
    hasCancelIcon: {
      type: Boolean,
      default: false,
    },
    remindText: {
      type: String,
    },
    remindTextColor: {
      type: String,
      default: 'red',
    },
    remindTextIcon: {
      type: String,
      default: 'icon-warning',
    },
    noErrorText: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dropdownMenuShow: false,
    isAddActive: false,
    createData: {},
    allMenuList: [],
  }),
  computed: {
    _hasValue() {
      return this.value && this.value.length > 0;
    },
    _selectValueList() {
      let allClassfication = [];
      this.allMenuList.forEach(menuItem => {
        menuItem.menu.forEach(item => allClassfication.push(item));
      });
      this.selectValue.forEach(valueItem => {
        allClassfication.push(valueItem);
      });

      return allClassfication;
    },
    _computedButtonTextLabel() {
      let placeholder = this.placeholder;
      let selectClassfication = [];
      this._selectValueList.forEach(system => {
        if (this.value.includes(system.value)) {
          selectClassfication.push(system.text);
        }
      });
      if (selectClassfication.length > 0) {
        return selectClassfication.join('、');
      }
      if (placeholder) return this.$t(placeholder);
      return this.menuItems[0].textLabel;
    },
    _remainNumber() {
      let selectNumber = this.value.length;
      return selectNumber;
    },
    _isDisplayCancelIcon() {
      return this.hasCancelIcon && this._hasValue;
    },
  },
  watch: {
    menuItems() {
      this.allMenuList = JSON.parse(JSON.stringify(this.menuItems));
    },
  },
  mounted() {
    this.allMenuList = JSON.parse(JSON.stringify(this.menuItems));
  },
  methods: {
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdownMenuShow = !this.dropdownMenuShow;
    },
    $_dropdownClose() {
      this.dropdownMenuShow = false;
      this.isAddActive = false;
      this.createData = {};
    },
    $_onChange($event, value) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ($event.target.checked) {
        if (!newValue.includes(value)) {
          newValue.push(value);
        }
      } else {
        newValue = newValue.filter(item => item !== value);
      }
      this.$emit('input', newValue);
    },
    $_addFieldOpen() {
      if (this.addLicenseTemplatePopUp) {
        this.$emit('btn-add-click');
      } else {
        this.dropdownMenuShow = false;
        this.isAddActive = true;
        this.createData = JSON.parse(JSON.stringify(this.addFields));
      }
    },
    $_addFieldClose() {
      this.isAddActive = false;
      this.createData = {};
      this.dropdownMenuShow = true;
    },
    $_btnClick() {
      this.$emit('btn-click');
    },
    async $_addSubmitClick() {
      const isValidate = await this.$refs.createObserve.validate();
      if (!isValidate) {
        return;
      }
      try {
        await this.$axios.post(this.addUrl, this.createData);
        this.$_dropdownClose();
      } catch (err) {
        alert(this.$t('新增發生錯誤'));
      }
    },
    $_onCancel() {
      this.$emit('input', []);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/dropdown-multiple-select-menu-button';
</style>
